import { normalize } from 'polished';
import React, { FC, ReactElement, useEffect, useMemo } from 'react';
import { createGlobalStyle, useTheme } from 'styled-components';
import theme from '@cld/theme-helper';

const GlobalStyle = createGlobalStyle`
  ${normalize()};

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  a,
  a:visited {
    text-decoration: none;
    color: ${theme`variant.primary.light`};
  }

  body {
    font-weight: normal;
    font-size: ${theme`globals.font.size`};
    font-family: ${theme`globals.font.family`};
    background-color: ${theme`palette.background`};
    color: ${theme`variant.background.text`};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    letter-spacing: normal;
  }

  .sbdocs-preview:first-child { // styling for main story
    & > :nth-child(2) {
      color: ${theme`variant.background.text`};
      background-color: ${theme`palette.background`};
      & > :nth-child(2) {
        background: none;
      }
    }
    & > :nth-child(3) {
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }
  }
  .sbdocs-preview:not(:first-child) { // styling for latter stories
    & > :nth-child(1) {
      color: ${theme`variant.background.text`};
      background-color: ${theme`palette.background`};
      & > :nth-child(2) {
        background: none;
      }
    }
    & > :nth-child(2) {
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }
  }
`;

const InjectFont: FC<{ children: ReactElement }> = ({ children }) => {
  const theme = useTheme();
  const fontElement = useMemo(() => document.createElement('link'), []);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any
  const fontUrl = (theme as any).globals.font.url as string;

  useEffect(() => {
    fontElement.rel = 'stylesheet';
    document.head.appendChild(fontElement);

    return () => {
      document.head.removeChild(fontElement);
    };
  }, [fontElement]);
  useEffect(() => {
    fontElement.href = fontUrl;
  }, [fontUrl, fontElement]);

  return children;
};

export default ((props) => (
  <InjectFont>
    <GlobalStyle {...props} />
  </InjectFont>
)) as FC;
